(() => {
  if (window.collectionSubtypesInitialized) return;
  window.collectionSubtypesInitialized = true;

  document.addEventListener('click', (event) => {
    const productCount = event.target.closest(
      '#ProductCount-Mobile[data-subtype-clear-url], #ProductCount-Desktop[data-subtype-clear-url]'
    );

    if (productCount) {
      const destination = new URL(productCount.dataset.subtypeClearUrl, window.location.origin);

      if (
        destination.origin === window.location.origin &&
        destination.pathname === window.location.pathname &&
        typeof FacetFiltersForm !== 'undefined' &&
        typeof FacetFiltersForm.renderPage === 'function'
      ) {
        event.preventDefault();
        FacetFiltersForm.renderPage(destination.searchParams.toString(), event);
      } else {
        window.location.href = destination.href;
      }
      return;
    }

    const link = event.target.closest('.rocket-collection-subtypes [data-subtype-value]');

    if (
      !link ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    if (link.dataset.subtypeNavigation === 'full') return;

    const destination = new URL(link.href, window.location.origin);
    const isSameCollection =
      destination.origin === window.location.origin &&
      destination.pathname === window.location.pathname;

    if (
      !isSameCollection ||
      typeof FacetFiltersForm === 'undefined' ||
      typeof FacetFiltersForm.renderPage !== 'function'
    ) {
      return;
    }

    event.preventDefault();
    FacetFiltersForm.renderPage(destination.searchParams.toString(), event);
  });
})();
